import { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { MEDIA_QUERIES } from '#/hooks/useResponsiveValue';
import {
  BreakpointKeys,
  CONTENT_MAX_WIDTH_PX,
  PICKER_MAX_WIDTH_PX,
} from '#/service/constants';
import { Path } from '#/service/routes';
import { remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { FullPageModal } from '../Modal/FullPageModal';
import { SignupStepIndicator } from '../StepIndicator/SignupStepIndicator';
import { stepInformation } from './PlanPurchaseFlow.hook';
import { PurchaseFlowStep } from './PlanPurchaseFlow.types';

export interface StepWrapperProps {
  step: PurchaseFlowStep.PURCHASE | PurchaseFlowStep.PICK;
}

const StepContainer = styled.div<{ $step: PurchaseFlowStep }>`
  display: grid;
  justify-items: center;
  align-content: start;
  text-align: left;
  margin: ${remify(80)} ${remify(16)} ${remify(75)};
  padding-top: ${remify(24)};
  width: 100%;
  outline: none;

  @media ${MEDIA_QUERIES[BreakpointKeys.XS]} {
    max-width: 100%;
  }
`;

const Container = styled.div<{ $step: PurchaseFlowStep }>`
  max-width: ${({ $step }) =>
    $step === PurchaseFlowStep.PICK
      ? remify(PICKER_MAX_WIDTH_PX)
      : remify(CONTENT_MAX_WIDTH_PX)};

  @media ${MEDIA_QUERIES[BreakpointKeys.XS]} {
    max-width: 100%;
  }
`;

export const StepWrapper: FC<PropsWithChildren<StepWrapperProps>> = ({
  children,
  step,
}) => {
  const { pathname } = useLocation();

  const { title, subtitle, stepNumber } = stepInformation[step];

  return (
    <StepContainer $step={step}>
      {pathname === Path.Registration && (
        <SignupStepIndicator currentStep={stepNumber} />
      )}
      <FullPageModal.Titles
        subtitle={tb(subtitle)}
        textAlign="center"
        title={tb(title)}
      />
      <Container $step={step}>{children}</Container>
    </StepContainer>
  );
};
